module.exports = __webpack_public_path__ + "03e986baadbc15bdf2057a38dde69d14.png";